import React from "react";
import "../styles/auction.css";

function AuctionItem({ title, image, currentBid, auctioneer, isForYou, onClick }) {
  return (
    <div className="auction-item" onClick={onClick}>
      <img
        src={image || "https://via.placeholder.com/300"}
        alt={title}
        className={isForYou ? "foryou-auction__image" : "auction-item__image"} // 🔹 Use larger image if For You
      />
      <div className="auction-item__details">
        <h3 className="auction-item__title">{title}</h3>
        <p className="auction-item__bid">Current Bid: AED {currentBid}</p>
        <p className="auction-item__auctioneer">Auctioneer: {auctioneer}</p>
      </div>
    </div>
  );
}

export default AuctionItem;
